
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.997 24.016v8.055c0 1.62-1.24 2.929-2.769 2.929H3.768C2.24 35 1 33.69 1 32.07V4.245c0-1.617 1.239-2.93 2.769-2.93h12.46c1.527 0 2.768 1.313 2.768 2.93v5.858M1 7.167h17.997M1 29.135h17.997M13.459 4.25H6.537","stroke":"#fff","stroke-width":"1.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.009 32.797c-.382 0-.692-.328-.692-.732 0-.404.31-.732.692-.732.382 0 .692.328.692.732 0 .404-.31.732-.692.732zM16.92 21.092l-3.461 1.464 1.384-3.661 9.691-10.252 2.077 2.197-9.691 10.252zM14.854 18.89l2.077 2.197","stroke":"#fff","stroke-width":"1.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    